import React from 'react';
import { Card } from '@/components/ui';
import type { MaintenanceAsset } from '../types/assets.types';

interface AssetMapViewProps {
  assets: MaintenanceAsset[];
}

export function AssetMapView({ assets }: AssetMapViewProps) {
  return (
    <Card className="w-full h-[600px] relative overflow-hidden bg-slate-50 flex items-center justify-center border-none shadow-sm">
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{ backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>

      <div className="text-center z-10 p-8">
        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <i className="ri-map-pin-2-line text-3xl text-emerald-600" />
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-2">Bản đồ Tài sản</h3>
        <p className="text-sm text-slate-500 max-w-md mx-auto mb-6">
          Tính năng GIS đang được đồng bộ hóa. Hiện tại có {assets.filter(a => a.gps_lat && a.gps_lng).length} tài sản đã được gắn tọa độ GPS.
        </p>

        <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto">
          {assets.slice(0, 4).map(asset => (
            <div key={asset.id} className="p-3 bg-white rounded-xl shadow-sm border border-slate-100 text-left">
              <p className="text-[10px] font-bold text-os-primary  truncate">{asset.asset_code}</p>
              <p className="text-xs text-slate-600 truncate">{asset.asset_name}</p>
              <div className="flex items-center gap-1 mt-1 text-[9px] text-slate-400">
                <i className="ri-gps-line" />
                <span>{asset.gps_lat?.toFixed(4)}, {asset.gps_lng?.toFixed(4)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Decorative map elements */}
      <div className="absolute top-1/4 left-1/3 w-4 h-4 bg-emerald-500 rounded-full border-2 border-white shadow-lg animate-pulse"></div>
      <div className="absolute top-1/2 left-2/3 w-4 h-4 bg-amber-500 rounded-full border-2 border-white shadow-lg"></div>
      <div className="absolute top-2/3 left-1/4 w-4 h-4 bg-emerald-500 rounded-full border-2 border-white shadow-lg"></div>
    </Card>
  );
}
